var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/**
 * Reusable Dropdown component
 *
 */
import React, { useRef, useId } from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { Container, ChosenOption, OptionText, TitleText } from './Dropdown.styled';
import Tether from '../Tether/Tether';
import { colors } from '../styleConstants';
import { Icon } from '../';
var OptionsContainer = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 0;\n  background-color: ", ";\n  outline: 1px solid ", ";\n  border-radius: 6px;\n  list-style: none;\n  margin: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 0;\n  background-color: ", ";\n  outline: 1px solid ", ";\n  border-radius: 6px;\n  list-style: none;\n  margin: 0;\n"])), colors.trueWhite, colors.primaryGreyLight);
var OptionItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 8px;\n  cursor: pointer;\n  &:hover {\n    background: ", ";\n    transition: 0.1s;\n  }\n  height: 28px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 8px;\n  cursor: pointer;\n  &:hover {\n    background: ", ";\n    transition: 0.1s;\n  }\n  height: 28px;\n"])), colors.primaryGreyLight);
var Dropdown = function (_a) {
    var options = _a.options, _b = _a.value, _value = _b === void 0 ? undefined : _b, onSelect = _a.onSelect, _c = _a.width, width = _c === void 0 ? undefined : _c;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(_value !== null && _value !== void 0 ? _value : options[0].value), value = _e[0], setValue = _e[1];
    var selectedOptionIdx = options.findIndex(function (o) { return o.value === value; });
    var _f = useState(selectedOptionIdx), selectedIdx = _f[0], setSelectedIdx = _f[1];
    var selectedOption = options[selectedIdx];
    var containerRef = useRef(null);
    var dropdownId = useId();
    var handleSelect = function (opt, idx) {
        setValue(opt.value);
        onSelect(opt);
        setSelectedIdx(idx);
        setOpen(false);
    };
    var computeVerticalShift = function () {
        // offset height of container plus half of border
        var defaultOffset = 40;
        var heightOfRow = 28;
        var shift = selectedIdx * heightOfRow + defaultOffset;
        return -shift;
    };
    return (React.createElement(Container, { width: width, ref: containerRef },
        React.createElement(ChosenOption, { onClick: function () {
                setOpen(!open);
            }, role: "button", "aria-haspopup": "listbox", "aria-expanded": open, "aria-controls": dropdownId },
            React.createElement(TitleText, null, selectedOption.label),
            React.createElement("div", null,
                React.createElement(Icon, { name: open ? 'chevron-up' : 'chevron-down', color: "black", size: "large", "aria-hidden": "true" }))),
        React.createElement(Tether, { target: containerRef, align: "bottom", show: open, offset: { horizontal: -8, vertical: computeVerticalShift() } },
            React.createElement(OptionsContainer, { role: "listbox", id: dropdownId, "aria-label": "Dropdown options" }, options.map(function (opt, idx) { return (React.createElement(OptionItem, { key: opt.value, onClick: function () { return handleSelect(opt, idx); }, role: "option", "aria-selected": selectedOption.value === opt.value },
                React.createElement(OptionText, null, opt.label),
                selectedOption.value === opt.value ? (React.createElement(Icon, { name: "check", color: "success", "aria-hidden": "true" })) : (React.createElement("div", { style: { width: 16, height: 16 }, "aria-hidden": "true" })))); })))));
};
export default Dropdown;
var templateObject_1, templateObject_2;
